import RecapBasket from 'components/Content/Recap/RecapBasket/RecapBasket';

export default RecapBasket;
